import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Slider, Tooltip } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import { valorsTaula } from "../../constantsObservacions";
import styles from "./VisualitzacioContainerTaula.module.css";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import {
  getVisibilitatObservacionsByCamp,
  getVisibilitatMenu,
  getDataInici,
  getDataFi,
  getPeticioVisualitzacioEnCurs,
  getTipusActiu
} from "../../reducers";
import { diasEntreDates, MASCARA_ISO_DIA } from "../../utils/dates";
import VisualitzacioMapaTitol from "./VisualitzacioMapaTitol";
import { TAULA } from "../../constantsFormularis";
import { FORMAT_DDMMYY } from "../../constantsObservacions";

class VisualitzacioContainerTaula extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diaCercaInicial: "",
      diaCercaFinal: ""
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.isPeticioVisEnCurs !== this.props.isPeticioVisEnCurs ||
      nextProps.visibilitatMenu !== this.props.visibilitatMenu ||
      this.state.diaCercaInicial !== nextState.diaCercaInicial ||
      this.state.diaCercaFinal !== nextState.diaCercaFinal
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.isPeticioVisEnCurs !== this.props.isPeticioVisEnCurs &&
      (nextProps.dataInici !== this.state.diaCercaInicial ||
        nextProps.dataFi !== this.state.diaCercaFinal)
    ) {
      this.setState({
        diaCercaInicial: nextProps.dataInici,
        diaCercaFinal: nextProps.dataFi
      });
    }
  }

  handleCanviDataSlider = (dataInici, dataFi) => {
    this.setState(() => {
      return {
        diaCercaInicial: dataInici,
        diaCercaFinal: dataFi
      };
    });
  };

  visualitzarControls = () => {
    const { observacionsPerObservador, tipusActiu } = this.props;
    const visualitzar =
      tipusActiu === TAULA &&
      Array.isArray(observacionsPerObservador) &&
      observacionsPerObservador.length > 0;

    return visualitzar;
  };

  esArrayConDatos = obj => {
    return obj && Array.isArray(obj) && obj.length > 0;
  };

  formatData = (observacions, arrayDates) => {
    const dadesAmbFormat = [];
    const observadors = {};

    if (!this.esArrayConDatos(observacions)) {
      return dadesAmbFormat;
    }

    observacions.forEach(obs => {
      if (!observadors.hasOwnProperty(obs.idObservador)) {
        observadors[obs.idObservador] = {
          nom: obs.permisMostrarNom
            ? `${obs.nomObservador} ${obs.cognom1Observador}`
            : "",
          codi: obs.nomUsuari,
          municipi: obs.nomMunicipi
        };
      }
    });

    let cont = 1;
    let indicadorComentariObservacio = "";
    Object.keys(observadors).forEach(idObservador => {
      const dadesObservador = {};
      dadesObservador.key = cont;
      dadesObservador.observador = {};
      dadesObservador.observador = observadors[idObservador];
      cont++;

      arrayDates.forEach(data => {
        const observacio = observacions.filter(obs => {
          return (
            obs.idObservador === parseInt(idObservador) &&
            obs.dataObservacio === data
          );
        });
        dadesObservador[data] = data;
        if (observacio.length > 0) {
          indicadorComentariObservacio =
            observacio[0].textComentari && observacio[0].textVisible
              ? `*#${observacio[0].textComentari}`
              : "#";
          dadesObservador[data] = `${dadesObservador[data]}%${valorsTaula[
            observacio[0].valorObservacio
          ]}${indicadorComentariObservacio}`;
        } else {
          dadesObservador[data] = `${dadesObservador[data]}%_#`;
        }
      });
      dadesAmbFormat.push(dadesObservador);
    });
    return dadesAmbFormat;
  };

  crearColumnesTaula = arrayDiasEntreDates => {
    const columns = [];

    arrayDiasEntreDates.forEach(dia => {
      const dadesDia = {
        width: "fit-content",
        dataIndex: dia,
        render: dia => (
          <Tooltip
            placement="top"
            overlayStyle={{ whiteSpace: "pre-line" }}
            title={
              moment(dia.substring(0, dia.indexOf("%"))).format(FORMAT_DDMMYY) +
              (dia.substring(dia.indexOf("#") + 1, dia.length)
                ? ": " + dia.substring(dia.indexOf("#") + 1, dia.length)
                : "")
            }
          >
            <div
              className={
                styles.tooltip +
                " " +
                (dia.substring(dia.indexOf("%") + 1, dia.indexOf("%") + 2) ===
                "S"
                  ? styles.tooltip_S
                  : dia.substring(
                      dia.indexOf("%") + 1,
                      dia.indexOf("%") + 2
                    ) === "N"
                    ? styles.tooltip_N
                    : dia.substring(
                        dia.indexOf("%") + 1,
                        dia.indexOf("%") + 2
                      ) === "d"
                      ? styles.tooltip_D
                      : styles.tooltip_B) +
                " " +
                styles.tooltip_mida_valors +
                " "
              }
            >
              {dia.substring(dia.indexOf("%") + 1, dia.indexOf("#"))}
            </div>
          </Tooltip>
        )
      };
      columns.push(dadesDia);
    });

    columns.unshift({
      title: "observador",
      dataIndex: "observador",
      fixed: "left",
      width: 150,
      render: observador => (
        <Tooltip
          placement="top"
          title={
            observador.nom ? (
              observador.nom + " - " + observador.municipi
            ) : (
              observador.municipi
            )
          }
        >
          <div className={styles.tooltip}>{observador.codi}</div>
        </Tooltip>
      )
    });

    return columns;
  };

  crearTextDatesSlider = arraydiasEntreDates => {
    function crearMark(dia) {
      const diaFormat = moment(dia).format(FORMAT_DDMMYY);
      const data = {
        style: {
          color: "#40a9ff"
        },
        label: (
          <span>
            <strong>{diaFormat}</strong>
          </span>
        )
      };
      return data;
    }

    const numDias = arraydiasEntreDates.length;
    const marks = {};
    const step = Math.trunc(numDias / 15) + 1;

    for (let i = 0; i < arraydiasEntreDates.length; i++) {
      if (i === 0 || i === arraydiasEntreDates.length - 1 || i % step === 0) {
        const dia = arraydiasEntreDates[i];
        const data = crearMark(dia);
        marks[i + 1] = data;
      }
    }

    return marks;
  };

  getFenofaseSeleccionada = (listaFenofases, idFenofase) => {
    return listaFenofases.filter(fenofase => {
      return fenofase.id === idFenofase;
    });
  };

  getEspecieSeleccionada = (listaEspecies, idEspecie) => {
    return listaEspecies.filter(especie => {
      return especie.id === idEspecie;
    });
  };

  render() {
    const {
      observacionsPerObservador,
      visibilitatMenu,
      dataInici,
      dataFi
    } = this.props;

    const arraydiasEntreDatesTaula = diasEntreDates(
      this.state.diaCercaInicial ? this.state.diaCercaInicial : dataInici,
      this.state.diaCercaFinal ? this.state.diaCercaFinal : dataFi,
      MASCARA_ISO_DIA
    );

    const arraydiasEntreDatesSlider = diasEntreDates(
      dataInici,
      dataFi,
      MASCARA_ISO_DIA
    );

    const data = this.formatData(
      observacionsPerObservador,
      arraydiasEntreDatesTaula
    );

    const columns = this.crearColumnesTaula(arraydiasEntreDatesTaula);
    const numDias = arraydiasEntreDatesSlider.length;

    const marks = this.crearTextDatesSlider(
      arraydiasEntreDatesSlider,
      dataInici,
      dataFi
    );

    const classNameMenuContainer = visibilitatMenu
      ? styles.visualitzacioContainerTaulaAmbMenu
      : styles.visualitzacioContainerTaulaSenseMenu;

    const classNameMenuContainerSlider = visibilitatMenu
      ? styles.visualitzacioContainerTaulaSliderAmbMenu
      : styles.visualitzacioContainerTaulaSliderSenseMenu;

    const onChange = value => {
      //TODO, No actualiza valores por defecto del Slider al selecionar una fecha inicial anterior o una fecha final posterior.
      //Las propiedades que se le pasan al componente Slider son correctas, tanto min, max como defaultValue ---> REVISAR
      // Si lo hace correctamente si se seleciona una fecha inicial posterior o una fecha final anterior. ???

      let newDiaInici, newDiaFi;

      newDiaInici = arraydiasEntreDatesSlider[parseInt(value[0]) - 1];
      newDiaFi = arraydiasEntreDatesSlider[parseInt(value[1]) - 1];

      this.handleCanviDataSlider(newDiaInici, newDiaFi);
    };

    return (
      <div className={styles.VisualitzacioContainerTaulaMapaPosition}>
        <div className={styles.titol_mapa}>
          <VisualitzacioMapaTitol />
        </div>
        <div
          className={
            styles.visualitzacioContainerTaula + " " + classNameMenuContainer
          }
        >
          <Table
            showHeader={this.visualitzarControls() ? true : false}
            columns={columns}
            dataSource={data}
            bordered
            size="small"
            pagination={{ pageSize: 50 }}
            scroll={{ x: "max-content", y: 600 }}
            className={styles.table_striped_rows}
          />
          <span className={styles.nota_comentari}>
            (*) Observació amb comentari
          </span>
        </div>

        {this.visualitzarControls() ? (
          <div
            className={
              styles.visualitzacioContainerTaulaSlider +
              " " +
              classNameMenuContainerSlider +
              " " +
              styles.ant_slider_with_marks
            }
          >
            <Slider
              marks={marks}
              tooltipVisible={false}
              min={1}
              max={numDias}
              dots={true}
              range
              step={1}
              defaultValue={[1, numDias]}
              onChange={onChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

VisualitzacioContainerTaula.propTypes = {
  props: PropTypes.object,
  observacionsPerObservador: PropTypes.array,
  visibilitatMenu: PropTypes.bool,
  dataInici: PropTypes.string.isRequired,
  dataFi: PropTypes.string.isRequired,
  isPeticioVisEnCurs: PropTypes.bool,
  tipusActiu: PropTypes.string
};

const mapStateToProps = state => ({
  observacionsPerObservador: getVisibilitatObservacionsByCamp(
    state,
    "idObservador"
  ),
  dataInici: getDataInici(state),
  dataFi: getDataFi(state),
  visibilitatMenu: getVisibilitatMenu(state),
  isPeticioVisEnCurs: getPeticioVisualitzacioEnCurs(state),
  tipusActiu: getTipusActiu(state)
});

export default ErrorBoundaryWrapper(
  connect(mapStateToProps)(VisualitzacioContainerTaula)
);
